// Système d'événements personnalisés pour la communication entre composants
class EventBus {
    constructor() {
        this.events = {};
    }

    // Écouter un événement
    on(event, callback) {
        if (!this.events[event]) {
            this.events[event] = [];
        }
        this.events[event].push(callback);

        // Retourner une fonction pour désabonner
        return () => {
            this.events[event] = this.events[event].filter(cb => cb !== callback);
        };
    }

    // Émettre un événement
    emit(event, data) {
        if (this.events[event]) {
            this.events[event].forEach(callback => {
                try {
                    callback(data);
                } catch (error) {
                    console.error(`Erreur lors de l'exécution du callback pour l'événement ${event}:`, error);
                }
            });
        }
    }

    // Supprimer tous les écouteurs d'un événement
    off(event) {
        if (this.events[event]) {
            delete this.events[event];
        }
    }

    // Supprimer tous les événements
    clear() {
        this.events = {};
    }
}

// Instance globale du bus d'événements
const eventBus = new EventBus();

// Événements spécifiques pour les offres d'alternance
export const EVENTS = {
    PROSPECT_ADDED_TO_OFFER: 'prospect_added_to_offer',
    PROSPECT_REMOVED_FROM_OFFER: 'prospect_removed_from_offer',
    CANDIDATES_LIST_UPDATE: 'candidates_list_update'
};

export default eventBus;
